<purple-api-error-wrapper [enabledErrorPages]="enableErrorPages" [loaderId]="loaderId"
  [reqConditions]="tsvc.isInitialized()" [pageBody]="content"></purple-api-error-wrapper>

<purple-loader [speed]="loaderSpeed" [width]="loaderWidth()" loaderPath="/assets/loaders/loader.json"
  [loaderId]="loaderId"></purple-loader>

<ng-template #content>

  @if (breakSvc.breakPointDevice() == 'desktop' || !showTabMenu) {
  <purple-fit-header></purple-fit-header>
  }

  <div
    class="purple-fit-layout-main-container {{!showTabMenuCurrentRoute? 'no-tab-space': ''}} {{showTabMenu && showTabMenuCurrentRoute?'tab-menu':''}}"
    (window:resize)="setAppHeight()">
    <div
      class="purple-fit-layout-main-container-internal {{userSvc.isLoggedIn?'':'no-bottom-space'}} {{layoutSvc.footerButton() != undefined?'has-footer-button':''}}">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- <button (click)="editTextSvc.toggleEditText()" class="purple-edit-button" nz-button nzType="primary">
    <span class="desktop-edit-button">Edit: {{(editTextSvc.editTextOn())? "active": "disable" }}</span>
  </button> -->
  @if (breakSvc.breakPointDevice() != 'desktop') {
  <purple-fit-footer></purple-fit-footer>
  }
</ng-template>
<purple-admin-tool></purple-admin-tool>